import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const PreviewModal = ({ properties, onClose, onPublish }) => {
  const [bulkEditField, setBulkEditField] = useState('');
  const [bulkEditValue, setBulkEditValue] = useState('');
  const [previewList, setPreviewList] = useState(properties);

  const validProperties = previewList?.filter(p => p?.address && p?.price && p?.bedrooms && p?.bathrooms && p?.type);

  const applyBulkEdit = () => {
    if (!bulkEditField || !bulkEditValue) return;
    setPreviewList(prev => prev?.map(p => ({ ...p, [bulkEditField]: bulkEditValue })));
    setBulkEditField('');
    setBulkEditValue('');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(8px)' }}>
      <div className="w-full max-w-3xl max-h-[90vh] flex flex-col rounded-2xl overflow-hidden" style={{ background: '#0D1829', border: '1px solid rgba(0,212,255,0.2)' }}>
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b" style={{ borderColor: 'rgba(255,255,255,0.08)' }}>
          <div>
            <h2 className="text-white font-bold text-lg">Preview Listings</h2>
            <p className="text-slate-400 text-sm">{validProperties?.length} properties ready to publish</p>
          </div>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-white/10 transition-colors">
            <Icon name="X" size={20} color="#94A3B8" />
          </button>
        </div>

        {/* Bulk Edit */}
        <div className="p-4 border-b" style={{ borderColor: 'rgba(255,255,255,0.06)', background: 'rgba(0,212,255,0.03)' }}>
          <p className="text-xs text-slate-400 mb-2 font-medium">Bulk Edit — Apply to all properties</p>
          <div className="flex gap-2">
            <select
              value={bulkEditField}
              onChange={e => setBulkEditField(e?.target?.value)}
              className="flex-1 px-3 py-2 rounded-lg text-sm text-white outline-none"
              style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}
            >
              <option value="">Select field to edit</option>
              <option value="type">Property Type</option>
              <option value="status">Status</option>
              <option value="agent">Agent Name</option>
            </select>
            <input
              type="text"
              value={bulkEditValue}
              onChange={e => setBulkEditValue(e?.target?.value)}
              placeholder="New value"
              className="flex-1 px-3 py-2 rounded-lg text-sm text-white placeholder-slate-500 outline-none"
              style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}
            />
            <button
              onClick={applyBulkEdit}
              className="px-4 py-2 rounded-lg text-sm font-medium text-cyan-400 border border-cyan-400/30 hover:bg-cyan-400/10 transition-colors whitespace-nowrap"
            >
              Apply All
            </button>
          </div>
        </div>

        {/* Property List */}
        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {previewList?.map((p, i) => {
            const isValid = p?.address && p?.price && p?.bedrooms && p?.bathrooms && p?.type;
            return (
              <div key={i} className="p-4 rounded-xl" style={{ background: 'rgba(255,255,255,0.03)', border: `1px solid ${isValid ? 'rgba(34,197,94,0.2)' : 'rgba(239,68,68,0.2)'}` }}>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className={`w-2 h-2 rounded-full ${isValid ? 'bg-green-400' : 'bg-red-400'}`} />
                      <p className="text-white font-medium text-sm">{p?.address || 'No address'}</p>
                    </div>
                    <div className="flex items-center gap-3 text-xs text-slate-400">
                      {p?.type && <span className="capitalize">{p?.type}</span>}
                      {p?.bedrooms && <span>{p?.bedrooms} bed</span>}
                      {p?.bathrooms && <span>{p?.bathrooms} bath</span>}
                      {p?.price && <span className="text-cyan-400 font-semibold">${parseFloat(p?.price)?.toLocaleString()}</span>}
                    </div>
                    {p?.description && (
                      <p className="text-slate-400 text-xs mt-2 line-clamp-2">{p?.description}</p>
                    )}
                  </div>
                  {!isValid && (
                    <span className="ml-3 text-xs text-red-400 bg-red-400/10 px-2 py-1 rounded-full">Incomplete</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div className="p-4 border-t flex items-center justify-between" style={{ borderColor: 'rgba(255,255,255,0.08)' }}>
          <p className="text-slate-400 text-sm">{validProperties?.length} of {previewList?.length} will be published</p>
          <div className="flex gap-3">
            <button onClick={onClose} className="px-4 py-2 rounded-lg text-sm text-slate-400 border border-white/10 hover:bg-white/5 transition-colors">
              Cancel
            </button>
            <button
              onClick={() => onPublish(validProperties)}
              disabled={validProperties?.length === 0}
              className="px-5 py-2 rounded-lg text-sm font-semibold text-black disabled:opacity-50 transition-all"
              style={{ background: 'linear-gradient(135deg, #00D4FF, #7B2FFF)' }}
            >
              Publish {validProperties?.length} Listings
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;
